export const sizes = ['small', 'medium', 'large']
export default sizes
